/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as NodesRouteImport } from './routes/nodes'
import { Route as OrganizationSetupRouteImport } from './routes/organization-setup'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAiUsageRouteImport } from './routes/admin/ai-usage'
import { Route as AdminScriptsRouteImport } from './routes/admin/scripts'
import { Route as AdminStatisticsRouteImport } from './routes/admin/statistics'
import { Route as AdminWaitlistRouteImport } from './routes/admin/waitlist'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsAccountRouteImport } from './routes/settings/account'
import { Route as SettingsDataRouteImport } from './routes/settings/data'
import { Route as SettingsIntegrationsRouteImport } from './routes/settings/integrations'
import { Route as SettingsInvitesRouteImport } from './routes/settings/invites'
import { Route as SettingsMembersRouteImport } from './routes/settings/members'
import { Route as SettingsOrganizationRouteImport } from './routes/settings/organization'
import { Route as SettingsPermissionsRouteImport } from './routes/settings/permissions'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations/index'
import { Route as AdminOrganizationsOrganizationIdRouteImport } from './routes/admin/organizations/$organizationId'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users/$userId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const NodesRoute = NodesRouteImport.update({
  id: '/nodes',
  path: '/nodes',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationSetupRoute = OrganizationSetupRouteImport.update({
  id: '/organization-setup',
  path: '/organization-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiUsageRoute = AdminAiUsageRouteImport.update({
  id: '/admin/ai-usage',
  path: '/admin/ai-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminScriptsRoute = AdminScriptsRouteImport.update({
  id: '/admin/scripts',
  path: '/admin/scripts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStatisticsRoute = AdminStatisticsRouteImport.update({
  id: '/admin/statistics',
  path: '/admin/statistics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWaitlistRoute = AdminWaitlistRouteImport.update({
  id: '/admin/waitlist',
  path: '/admin/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsAccountRoute = SettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsDataRoute = SettingsDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsIntegrationsRoute = SettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsInvitesRoute = SettingsInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsOrganizationRoute = SettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsPermissionsRoute = SettingsPermissionsRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/admin/organizations/',
  path: '/admin/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationsOrganizationIdRoute =
  AdminOrganizationsOrganizationIdRouteImport.update({
    id: '/admin/organizations/$organizationId',
    path: '/admin/organizations/$organizationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/nodes': typeof NodesRoute
  '/organization-setup': typeof OrganizationSetupRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/waitlist': typeof WaitlistRoute
  '/welcome': typeof WelcomeRoute
  '/admin/ai-usage': typeof AdminAiUsageRoute
  '/admin/scripts': typeof AdminScriptsRoute
  '/admin/statistics': typeof AdminStatisticsRoute
  '/admin/waitlist': typeof AdminWaitlistRoute
  '/invite/$token': typeof InviteTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/invites': typeof SettingsInvitesRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/permissions': typeof SettingsPermissionsRoute
  '/admin/': typeof AdminIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/admin/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/nodes': typeof NodesRoute
  '/organization-setup': typeof OrganizationSetupRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/waitlist': typeof WaitlistRoute
  '/welcome': typeof WelcomeRoute
  '/admin/ai-usage': typeof AdminAiUsageRoute
  '/admin/scripts': typeof AdminScriptsRoute
  '/admin/statistics': typeof AdminStatisticsRoute
  '/admin/waitlist': typeof AdminWaitlistRoute
  '/invite/$token': typeof InviteTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/invites': typeof SettingsInvitesRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/permissions': typeof SettingsPermissionsRoute
  '/admin': typeof AdminIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/admin/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/nodes': typeof NodesRoute
  '/organization-setup': typeof OrganizationSetupRoute
  '/signin': typeof SigninRoute
  '/signup': typeof SignupRoute
  '/waitlist': typeof WaitlistRoute
  '/welcome': typeof WelcomeRoute
  '/admin/ai-usage': typeof AdminAiUsageRoute
  '/admin/scripts': typeof AdminScriptsRoute
  '/admin/statistics': typeof AdminStatisticsRoute
  '/admin/waitlist': typeof AdminWaitlistRoute
  '/invite/$token': typeof InviteTokenRoute
  '/settings/account': typeof SettingsAccountRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/integrations': typeof SettingsIntegrationsRoute
  '/settings/invites': typeof SettingsInvitesRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/organization': typeof SettingsOrganizationRoute
  '/settings/permissions': typeof SettingsPermissionsRoute
  '/admin/': typeof AdminIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/admin/organizations/$organizationId': typeof AdminOrganizationsOrganizationIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/about'
    | '/nodes'
    | '/organization-setup'
    | '/signin'
    | '/signup'
    | '/waitlist'
    | '/welcome'
    | '/admin/ai-usage'
    | '/admin/scripts'
    | '/admin/statistics'
    | '/admin/waitlist'
    | '/invite/$token'
    | '/settings/account'
    | '/settings/data'
    | '/settings/integrations'
    | '/settings/invites'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/permissions'
    | '/admin/'
    | '/settings/'
    | '/admin/organizations/$organizationId'
    | '/admin/users/$userId'
    | '/admin/organizations/'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/nodes'
    | '/organization-setup'
    | '/signin'
    | '/signup'
    | '/waitlist'
    | '/welcome'
    | '/admin/ai-usage'
    | '/admin/scripts'
    | '/admin/statistics'
    | '/admin/waitlist'
    | '/invite/$token'
    | '/settings/account'
    | '/settings/data'
    | '/settings/integrations'
    | '/settings/invites'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/permissions'
    | '/admin'
    | '/settings'
    | '/admin/organizations/$organizationId'
    | '/admin/users/$userId'
    | '/admin/organizations'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/settings'
    | '/about'
    | '/nodes'
    | '/organization-setup'
    | '/signin'
    | '/signup'
    | '/waitlist'
    | '/welcome'
    | '/admin/ai-usage'
    | '/admin/scripts'
    | '/admin/statistics'
    | '/admin/waitlist'
    | '/invite/$token'
    | '/settings/account'
    | '/settings/data'
    | '/settings/integrations'
    | '/settings/invites'
    | '/settings/members'
    | '/settings/organization'
    | '/settings/permissions'
    | '/admin/'
    | '/settings/'
    | '/admin/organizations/$organizationId'
    | '/admin/users/$userId'
    | '/admin/organizations/'
    | '/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  NodesRoute: typeof NodesRoute
  OrganizationSetupRoute: typeof OrganizationSetupRoute
  SigninRoute: typeof SigninRoute
  SignupRoute: typeof SignupRoute
  WaitlistRoute: typeof WaitlistRoute
  WelcomeRoute: typeof WelcomeRoute
  AdminAiUsageRoute: typeof AdminAiUsageRoute
  AdminScriptsRoute: typeof AdminScriptsRoute
  AdminStatisticsRoute: typeof AdminStatisticsRoute
  AdminWaitlistRoute: typeof AdminWaitlistRoute
  InviteTokenRoute: typeof InviteTokenRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminOrganizationsOrganizationIdRoute: typeof AdminOrganizationsOrganizationIdRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nodes': {
      id: '/nodes'
      path: '/nodes'
      fullPath: '/nodes'
      preLoaderRoute: typeof NodesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization-setup': {
      id: '/organization-setup'
      path: '/organization-setup'
      fullPath: '/organization-setup'
      preLoaderRoute: typeof OrganizationSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ai-usage': {
      id: '/admin/ai-usage'
      path: '/admin/ai-usage'
      fullPath: '/admin/ai-usage'
      preLoaderRoute: typeof AdminAiUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/scripts': {
      id: '/admin/scripts'
      path: '/admin/scripts'
      fullPath: '/admin/scripts'
      preLoaderRoute: typeof AdminScriptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/statistics': {
      id: '/admin/statistics'
      path: '/admin/statistics'
      fullPath: '/admin/statistics'
      preLoaderRoute: typeof AdminStatisticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/waitlist': {
      id: '/admin/waitlist'
      path: '/admin/waitlist'
      fullPath: '/admin/waitlist'
      preLoaderRoute: typeof AdminWaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/account': {
      id: '/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof SettingsAccountRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/data': {
      id: '/settings/data'
      path: '/data'
      fullPath: '/settings/data'
      preLoaderRoute: typeof SettingsDataRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/integrations': {
      id: '/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/invites': {
      id: '/settings/invites'
      path: '/invites'
      fullPath: '/settings/invites'
      preLoaderRoute: typeof SettingsInvitesRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/members': {
      id: '/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof SettingsMembersRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/organization': {
      id: '/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof SettingsOrganizationRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/permissions': {
      id: '/settings/permissions'
      path: '/permissions'
      fullPath: '/settings/permissions'
      preLoaderRoute: typeof SettingsPermissionsRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations/$organizationId': {
      id: '/admin/organizations/$organizationId'
      path: '/admin/organizations/$organizationId'
      fullPath: '/admin/organizations/$organizationId'
      preLoaderRoute: typeof AdminOrganizationsOrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/admin/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteRouteChildren {
  SettingsAccountRoute: typeof SettingsAccountRoute
  SettingsDataRoute: typeof SettingsDataRoute
  SettingsIntegrationsRoute: typeof SettingsIntegrationsRoute
  SettingsInvitesRoute: typeof SettingsInvitesRoute
  SettingsMembersRoute: typeof SettingsMembersRoute
  SettingsOrganizationRoute: typeof SettingsOrganizationRoute
  SettingsPermissionsRoute: typeof SettingsPermissionsRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsAccountRoute: SettingsAccountRoute,
  SettingsDataRoute: SettingsDataRoute,
  SettingsIntegrationsRoute: SettingsIntegrationsRoute,
  SettingsInvitesRoute: SettingsInvitesRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsOrganizationRoute: SettingsOrganizationRoute,
  SettingsPermissionsRoute: SettingsPermissionsRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  NodesRoute: NodesRoute,
  OrganizationSetupRoute: OrganizationSetupRoute,
  SigninRoute: SigninRoute,
  SignupRoute: SignupRoute,
  WaitlistRoute: WaitlistRoute,
  WelcomeRoute: WelcomeRoute,
  AdminAiUsageRoute: AdminAiUsageRoute,
  AdminScriptsRoute: AdminScriptsRoute,
  AdminStatisticsRoute: AdminStatisticsRoute,
  AdminWaitlistRoute: AdminWaitlistRoute,
  InviteTokenRoute: InviteTokenRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminOrganizationsOrganizationIdRoute: AdminOrganizationsOrganizationIdRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
